<nav #navbar class="navbar navbar-expand-lg navbar-absolute bg-up">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button
          mat-raised-button
          (click)="minimizeSidebar()"
          class="btn btn-just-icon btn-white btn-fab btn-round"
          style="color: #424d65; font-size: 22px"
        >
          <span>
            <i
              class="ri-bar-chart-horizontal-fill text_align-center visible-on-sidebar-regular"
              style="font-size: 22px"
            ></i>
          </span>

          <span
            ><i
              class="ri-bar-chart-horizontal-fill design_bullet-list-67 visible-on-sidebar-mini"
              style="font-size: 22px"
            ></i
          ></span>
        </button>
      </div>
      <a class="navbar-brand" href="{{ getPath() }}"> {{ getTitle() }}</a>
    </div>
    <button
      mat-button
      class="navbar-toggler btn-no-ripple"
      type="button"
      (click)="sidebarToggle()"
    >
      <span class="sr-only">Toggle navigation</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navigation">
      <ul class="navbar-nav">
        <li
          class="nav-item dropdown"
          style="
            background: #3167f3;
            color: #fff;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0;
            margin: 0;
          "
        >
          <a
            class="d-flex align-items-center"
            href="javascript:void(0)"
            (click)="utility.logoutUser()"
            style="gap: 5px"
          >
            <i
              class="material-icons"
              style="
                margin: 0;
                position: unset;
                width: unset;
                color: #fff;
                font-size: 18px;
              "
              >power_settings_new</i
            >
            <span class="d-lg-none d-md-block">Logout</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
